import { useTranslation } from "@redotech/redo-i18n";
import PhoneIcon from "@redotech/redo-icons/phone.svg";
import PhoneFilledIcon from "@redotech/redo-icons/phone_filled.svg";
import { memo } from "react";
import { PrimaryNavigationTab } from "../arbiter-components/navigation/primary/redo-primary-nav-tab";
import {
  PageNavigationEntry,
  RedoSideNavigation,
} from "../arbiter-components/navigation/redo-side-navigation";
import { usePhoneWidget } from "../voice/shared/phone-widget-context";
import { RedoNavigationTeamItem } from "./common/redo-nav-team-item";
import { UserProfile } from "./common/redo-nav-user-profile";
import type { SettingsSection } from "./redo-settings-nav";
import { RedoSettingsNav } from "./redo-settings-nav.new";

const PhonePrimaryNavTab = memo(function PhonePrimaryNavTab() {
  const { t } = useTranslation();
  const { isVisible, toggleVisibility, isVoiceAvailable } = usePhoneWidget();

  if (!isVoiceAvailable) {
    return null;
  }

  return (
    <PrimaryNavigationTab
      manuallySelected={isVisible}
      tab={{
        id: "phone",
        UnfilledIcon: PhoneIcon,
        FilledIcon: PhoneFilledIcon,
        type: "button",
        friendlyName: t("Phone", { context: "navigation menu" }),
        hasNotification: false,
        hideLabel: true,
        onClick: toggleVisibility,
      }}
    />
  );
});

export const RedoAppSideNavigation = memo(function RedoAppSideNavigation({
  isHidden,
  enterSettingsUrl,
  exitSettingsUrl,
  settingsRoot,
  pageEntries,
  settingSections,
  settingsNavVariant = "legacy",
  hideTeamSwitcher = false,
}: {
  isHidden: boolean;
  enterSettingsUrl: string;
  exitSettingsUrl: string;
  settingsRoot: string;
  pageEntries: PageNavigationEntry[];
  settingSections: SettingsSection[] | null;
  settingsNavVariant?: "legacy" | "redesigned";
  hideTeamSwitcher?: boolean;
}) {
  return (
    <RedoSideNavigation
      enterSettingsUrl={enterSettingsUrl}
      isHidden={isHidden}
      pageEntries={pageEntries}
      primaryNavActions={<PhonePrimaryNavTab />}
      renderSettingsNav={
        settingSections
          ? ({ hidden }) => (
              <RedoSettingsNav
                exitSettingsUrl={hidden ? undefined : exitSettingsUrl}
                hidden={hidden}
                sections={settingSections}
                variant={settingsNavVariant}
              />
            )
          : undefined
      }
      settingsRoot={settingsRoot}
      teamSwitcher={hideTeamSwitcher ? undefined : <RedoNavigationTeamItem />}
      userProfile={<UserProfile collapsed />}
    />
  );
});
